<template>
    <div>
        <CreateUser />
    </div>
</template>

<script>
import CreateUser from '@/components/user/CreateUser.vue';
export default {
    components: {
        CreateUser
    },
    name: 'UserCreate'
}
</script>